export default __webpack_public_path__ + "static/GRID22-breakdown-es-1c2679e06bfcb21a1f4452518e94b152.png";